<div
  class="card chat-user-info mb-0 simplebar-scrollable-y h-100 offcanvas-start file-offcanvas"
  data-simplebar="init"
  [@slideInOut]="sidebarState"
>
  <div class="simplebar-wrapper">
    <div class="simplebar-mask">
      <div class="simplebar-offset">
        <div
          class="simplebar-content-wrapper"
          tabindex="0"
          role="region"
          aria-label="scrollable-content"
        >
          <div class="simplebar-content">
            <!-- Tab navigation — shown when Copilot or CRM is enabled -->
            @if (attendance && (copilotEnabled || getModuleCRM())) {
              <ul
                #tabs
                class="nav nav-tabs nav-bordered flex-nowrap mb-0 border-bottom attendance-panel-tabs"
              >
                @if (copilotEnabled) {
                  <li class="nav-item">
                    <a
                      class="nav-link text-truncate"
                      [class.active]="activeTab === 'copilot'"
                      href="javascript:void(0);"
                      (click)="setActiveTab('copilot')"
                    >
                      <i class="ri-robot-2-line me-1"></i>Copilot
                      @if (insightAvailable) {
                        <span
                          class="badge text-bg-primary ms-1"
                          role="img"
                          [attr.aria-label]="'attendance.copilot.insight.marker' | translate"
                        >
                          <i class="ri-lightbulb-line"></i>
                        </span>
                      }
                    </a>
                  </li>
                }
                <li class="nav-item">
                  <a
                    class="nav-link text-truncate"
                    [class.active]="activeTab === 'contact'"
                    href="javascript:void(0);"
                    (click)="setActiveTab('contact')"
                  >
                    <i class="ri-user-line me-1"></i
                    >{{ "attendance.panelInfo.contact" | translate }}
                  </a>
                </li>
                @if (getModuleCRM()) {
                  <li class="nav-item">
                    <a
                      class="nav-link text-truncate"
                      [class.active]="activeTab === 'opportunity'"
                      href="javascript:void(0);"
                      (click)="setActiveTab('opportunity')"
                    >
                      <i class="ri-filter-3-line me-1"></i
                      >{{ "attendance.panelInfo.opportunity" | translate }}
                    </a>
                  </li>
                }
              </ul>
            }

            <!-- Copilot tab — no top gutter of its own: the summary strip pins itself right under the tabs
                 (their measured height is its offset) and carries the gutter, so the chat scrolls under a solid block -->
            @if (attendance && copilotEnabled && activeTab === "copilot") {
              <div
                class="card-body d-flex flex-column pt-0 pb-0"
                [style.--attendance-panel-tabs-height]="tabsHeight + 'px'"
              >
                <attendance-copilot-tab
                  [idAttendance]="attendance._id"
                  [copilotReady]="copilotReady"
                  [copilotMinMessages]="copilotMinMessages"
                  [attendanceClosed]="attendanceClosed"
                />
              </div>
            }

            <!-- Contact tab -->
            <div class="card-body" [class.d-none]="activeTab !== 'contact'">
              @if (attendance) {
                <div>
                  <!-- ** TODO: Foi pedido para comentar provisoriamente ** <div class="dropdown float-end">
                    <a
                      href="#"
                      class="dropdown-toggle arrow-none card-drop"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="mdi mdi-dots-horizontal"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a href="javascript:void(0);" class="dropdown-item" (click)="toggleInfo = !toggleInfo">
                        {{ toggleInfo ? 'Exibir informações' : 'Esconder informações'}}
                      </a>
                    </div>
                  </div> -->
                </div>

                <div class="mt-3">
                  <contact-info-component />
                  <service-tag-attendance />
                  <app-add-lead-source />
                  <service-note-attendance />
                  <custom-field-attendance class="custom-field-container" />
                  <!-- <app-sales-monitor-attendance /> -->
                </div>
              }
            </div>

            <!-- Opportunity tab -->
            @if (attendance && getModuleCRM() && activeTab === "opportunity") {
              <div class="m-1">
                <attendance-opportunity-tab [attendance]="attendance" />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
